<section class="menu_section">
    <div class="container ">
        <div *ngIf="_authSvc.isLoggedIn()" class="container-fluid">
            <!-- <div class="row ">
                <div class="topnav_header">
                    <div class="column">
                        <div>
                            <img class="logo-img" routerLink="Order" routerLinkActive="active" src="../../../../assets/images/dryclean_New_AllPages_logo_v4.png" alt="" />
                        </div>
                    </div>
                    <div class="column">
                        <label class="dropdown">
                            <div class="dropdown-user" style="background-color: #ffffff;">
                                <img class="user_logo" src="../../../../assets/images/login-logow.png">
        
                                {{_authSvc?.LoginUserName}}
        
                            </div>
                            <input type="checkbox" class="dd-logout" id="test">
                            
                            <button class="dropdown-logout" (click)="logout()">Logout</button>
                        </label>
                    </div>
                </div>
            </div> -->

            <div class="row ">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img class="logo-img" routerLink="Order" routerLinkActive="active" src="../../../../assets/images/dryclean_New_AllPages_logo_v4.png" alt="" />
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                    <button type="button" (click)="showHideMenu()" data-target="#navbarCollapse" data-toggle="collapse" aria-expanded="false" class="navbar-toggle collapsed" style="/*! position: absolute; */top: 0px;left: 8px;background-color: #d22f28;color: #fff;">
                        <span class="icon-bar" style="background-color: #fff;"></span>
                        <span class="icon-bar" style="background-color: #fff;"></span>
                        <span class="icon-bar" style="background-color: #fff;"></span>
                    </button>
                    <label class="dropdown">
                        <div class="dropdown-user" style="background-color: #ffffff;">
                            <img class="user_logo" src="../../../../assets/images/login-logow.png">
                            {{_authSvc?.LoginUserName}}
                        </div>
                        <input type="checkbox" class="dd-logout" id="test">
                        <button class="dropdown-logout" (click)="logout()">Logout</button>
                    </label>

                </div>

            </div>
        </div>
    </div>
</section>

<section *ngIf="isMenuShow" class="menu_section_snd">
    <div class="container">
        <div *ngIf="_authSvc.isLoggedIn()" class="">
            <div class="row ">
                <div class="main_menu">
                    <ul class="header_nav">
                        <li>
                            <a routerLink="/Order" routerLinkActive="active">Orders</a>
                        </li>
                        <li><a routerLink="/ClassSummaryReport" routerLinkActive="active">Class Summary</a></li>
                        <li><a routerLink="/LotTaggingReport" routerLinkActive="active">Tag Report</a></li>
                        <li><a routerLink="/Drivers" routerLinkActive="active">Drivers</a></li>
                        <li><a routerLink="/Devices" routerLinkActive="active">Devices</a></li>
                        <li><a routerLink="/CustomerWiseInvoicesSummaryReport" routerLinkActive="active">CC Payment
                                    Report</a></li>
                        <li><a routerLink="/CustomerWiseSummaryReport" routerLinkActive="active">Customers</a></li>
                        <li><a routerLink="/Employee" routerLinkActive="active">Employee</a></li>
                        <li><a routerLink="/ContentManager" routerLinkActive="active">Content Management</a></li>
                        <!-- <li><a routerLink="/referralSummary" routerLinkActive="active">Referral Summary</a></li> -->

                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>